// :: Dependencies
import { SET_DATA_SEARCH, SET_IMAGE_KPI } from "./mutation-types";
import { firestore, database, firebase, firestoreDb } from "@/config/firebase";
import { errorMessage, showMessage } from "@/services/MessageService";
import store from "@/store";
export default {
  getAccesSections({ state }, data) {
    state.prosicEvents = {
      delivery: {
        title: "ENTREGAS",
        value: "delivery",
        counter: 0
      },
      maintenance: {
        title: "MANTENIMIENTO",
        value: "maintenance",
        counter: 0
      },
      recollection: {
        title: "RECOLECCIÓN",
        value: "recollection",
        counter: 0
      },
      relocation: {
        title: "REUBICACIÓN",
        value: "relocation",
        counter: 0
      },
      rentedService: {
        title: "RENTADO SERVICIO",
        value: "rented-service",
        counter: 0
      }
    };
    if (!data["damage-read-delivery"]) {
      if (!data["damage-write-delivery"]) delete state.prosicEvents.delivery;
    }
    if (!data["damage-read-maintenance"]) {
      if (!data["damage-write-maintenance"])
        delete state.prosicEvents.maintenance;
    }
    if (!data["damage-read-recollection"]) {
      if (!data["damage-write-recollection"])
        delete state.prosicEvents.recollection;
    }
    if (!data["damage-read-relocation"]) {
      if (!data["damage-write-relocation"])
        delete state.prosicEvents.relocation;
    }
    if (!data["damage-read-rentedservice"]) {
      if (!data["damage-write-rentedservice"])
        delete state.prosicEvents.rentedService;
    }
    if (!data["damage-write-delivery"]) {
      if (!data["damage-read-delivery"]) delete state.prosicEvents.delivery;
    }
    if (!data["damage-write-maintenance"]) {
      if (!data["damage-read-maintenance"])
        delete state.prosicEvents.maintenance;
    }
    if (!data["damage-write-recollection"]) {
      if (!data["damage-read-recollection"])
        delete state.prosicEvents.recollection;
    }
    if (!data["damage-write-relocation"]) {
      if (!data["damage-read-relocation"]) delete state.prosicEvents.relocation;
    }
    if (!data["damage-write-rentedservice"]) {
      if (!data["damage-read-rentedservice"])
        delete state.prosicEvents.rentedService;
    }

    let events = {};
    if (state.prosicEvents.delivery) events.totalDeliveries = 0;
    if (state.prosicEvents.maintenance) events.totalRecollections = 0;
    if (state.prosicEvents.recollection) events.totalMaintenances = 0;
    if (state.prosicEvents.relocation) events.totalRelocations = 0;
    if (state.prosicEvents.rentedService) events.totalRentedServices = 0;

    state.totalEventCounter = events;

    if (state.prosicEvents.delivery)
      state.menuOrderTypeArray.push({ text: "Entregas", value: "delivery" });
    if (state.prosicEvents.maintenance)
      state.menuOrderTypeArray.push({
        text: "Mantenimiento",
        value: "maintenance"
      });
    if (state.prosicEvents.recollection)
      state.menuOrderTypeArray.push({
        text: "Recolecciones",
        value: "recollection"
      });
    if (state.prosicEvents.relocation)
      state.menuOrderTypeArray.push({
        text: "Reubicación",
        value: "relocation"
      });
    if (state.prosicEvents.rentedService)
      state.menuOrderTypeArray.push({
        text: "Rentado Servicio",
        value: "rented-service"
      });
  },
  async getDataSearchOrders({ commit }, nodeDatabase) {
    const refactorData = {};
    const data = await database(nodeDatabase).once("value");
    if (data.exists()) {
      const tempData = data.val();
      for (const key in tempData) {
        if (Object.hasOwnProperty.call(tempData, key)) {
          const refactorKey = key.replace(/_/g, "/");
          refactorData[refactorKey] = true;
        }
      }
      commit(SET_DATA_SEARCH, refactorData);
    } else {
      commit(SET_DATA_SEARCH, {});
    }
  },
  async getDataSearchSeries({ commit }) {
    const seriesData = {};
    const data = await database("damageSeries").once("value");
    if (data.exists()) {
      const tempData = data.val();
      for (const key in tempData) {
        if (Object.hasOwnProperty.call(tempData, key)) {
          const refactorKey = key.replace(/_/g, "/");
          const element = tempData[key];
          seriesData[refactorKey] = element;
        }
      }
      commit(SET_DATA_SEARCH, seriesData);
    } else {
      commit(SET_DATA_SEARCH, {});
    }
  },
  async saveURL_KPI({ commit }, chartsData) {
    try {
      const images = [];
      for (const chart of chartsData.docs) {
        const snapsData = await firestore("indicators/board/charts")
          .doc(chart.id)
          .collection("snaps")
          .orderBy("date", "desc")
          .limit(1)
          .get();
        const storageRef = firebase.storage().ref();
        if (snapsData.docs[0]) {
          const url = await storageRef
            .child(snapsData.docs[0].data().storageRef)
            .getDownloadURL();
          images.push({ src: url });
        }
      }
      commit(SET_IMAGE_KPI, images);
    } catch {
      errorMessage("Ha ocurrido un error inesperado al obtener las URL");
    }
  },
  async getImagesKPI({ dispatch }, branch) {
    try {
      let chartsData;
      const access = store.state.user.userAccess;
      if (access["show-kpi"] && !access["admin-kpi"]) {
        chartsData = await firestore("indicators/board/charts")
          .where("branch", "==", branch)
          .get();
      } else if (access["admin-kpi"]) {
        chartsData = await firestore("indicators/board/charts").get();
      }
      await dispatch("saveURL_KPI", chartsData);
    } catch {
      errorMessage("Ha ocurrido un error inesperado en la consulta de KPI's");
    }
  },
  async getDataKpis(_, branch) {
    let dataKpis;
    if (branch) {
      dataKpis = await firestore("indicators/board/charts")
        .where("branch", "==", branch)
        .where("active", "==", true)
        .get();
    } else {
      dataKpis = await firestore("indicators/board/charts")
        .where("active", "==", true)
        .get();
    }
    return dataKpis;
  },
  async saveKpi(_, data) {
    try {
      if (data) {
        const newKpi = await firestore("indicators/board/charts").doc();
        newKpi.set(data);
        showMessage({
          message: "El indicador se ha guardado exitosamente",
          color: "success"
        });
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error al guardar el indicador");
    }
  },
  async deleteMultiplesKpis(_, items) {
    try {
      if (items.length > 0) {
        const batch = firestoreDb.batch();
        for (const kpi of items) {
          const kpiRef = await firestore("indicators/board/charts").doc(
            kpi.uid
          );
          batch.update(kpiRef, { active: false });
        }
        batch.commit();
        showMessage({
          message: "El indicador se ha eliminado exitosamente",
          color: "success"
        });
      } else errorMessage("No hay indicadores seleccionados");
    } catch (error) {
      errorMessage("Error al elimnar el indicador");
    }
  },
  async deleteKpi(_, uid) {
    try {
      if (uid) {
        const kpi = await firestore("indicators/board/charts").doc(uid);
        kpi.update({
          active: false
        });
        showMessage({
          message: "El indicador se ha eliminado exitosamente",
          color: "success"
        });
      } else errorMessage("Error al elimnar el indicador");
    } catch (error) {
      errorMessage("Error al elimnar el indicador");
    }
  },
  async saveImportRegisters(_, records) {
    try {
      if (records.length > 0) {
        const batch = firestoreDb.batch();
        for (const kpi of records) {
          const kpiRef = await firestore("indicators/board/charts").doc();
          batch.set(kpiRef, kpi);
        }
        batch.commit();
        showMessage({
          message: "Se han guardado exitosamente los indicadores",
          color: "success"
        });
      } else errorMessage("No hay indicadores seleccionados");
    } catch (error) {
      errorMessage("Error al guardar los indicadores" + error);
    }
  }
};
